<div class="content-box">
  <app-breadcrumb pagina="Ouvidoria"></app-breadcrumb>

  <section class="ouvidoria" aria-labelledby="ouvidoria-titulo">
    <div class="ouvidoria-topo">
      <h1 class="ouvidoria-titulo" id="ouvidoria-titulo">Ouvidoria Geral do Município</h1>
      <span class="ouvidoria-traco" aria-hidden="true"></span>

      <p class="ouvidoria-subtitulo">
        Canal oficial para registrar manifestações, solicitações e acompanhar atendimentos ao cidadão.
      </p>
    </div>

    <ul class="ouvidoria-grade">
      @for (canal of canais; track canal.id) {
        <li>
          @if (canal.link) {
            <a class="ouvidoria-card" [attr.data-cor]="canal.cor" [routerLink]="canal.link">
              <span class="ouvidoria-card-esfera" aria-hidden="true">
                <i-lucide [name]="canal.icone" size="34"></i-lucide>
              </span>

              <span class="ouvidoria-card-titulo">{{ canal.titulo }}</span>
            </a>
          } @else {
            <button type="button" class="ouvidoria-card" [attr.data-cor]="canal.cor">
              <span class="ouvidoria-card-esfera" aria-hidden="true">
                <i-lucide [name]="canal.icone" size="34"></i-lucide>
              </span>

              <span class="ouvidoria-card-titulo">{{ canal.titulo }}</span>
            </button>
          }
        </li>
      }
    </ul>

    @if (canal()) {
      <section class="ouvidoria-info" aria-labelledby="ouvidoria-info-titulo">
        <img
          class="ouvidoria-info-ilustracao"
          ngSrc="assets/images/ouvidoria/ouvidoria-ilustracao.png"
          width="300"
          height="237"
          priority
          alt=""
        />

        <div class="ouvidoria-info-corpo">
          <div class="ouvidoria-info-cabecalho">
            <span class="ouvidoria-info-selo" aria-hidden="true">
              <i-lucide name="info" size="18"></i-lucide>
            </span>

            <h2 class="ouvidoria-info-titulo" id="ouvidoria-info-titulo">Informações da Ouvidoria</h2>
          </div>

          <span class="ouvidoria-traco ouvidoria-traco-info" aria-hidden="true"></span>

          <p class="ouvidoria-info-responsavel">
            <i-lucide name="user-round" size="14" aria-hidden="true"></i-lucide>
            <span>Responsável</span>
            <span class="ouvidoria-info-responsavel-nome">{{ responsavel() }}</span>
          </p>

          <dl class="ouvidoria-info-grade">
            @for (info of informacoes(); track info.id) {
              <div class="ouvidoria-info-item">
                <dt class="ouvidoria-info-rotulo">
                  <i-lucide [name]="info.icone" size="14" aria-hidden="true"></i-lucide>
                  <span>{{ info.rotulo }}</span>
                </dt>

                <dd class="ouvidoria-info-valor">
                  @for (valor of info.valores; track valor.texto) {
                    <span class="ouvidoria-info-linha">
                      @if (href(valor); as endereco) {
                        <a class="ouvidoria-info-link" [href]="endereco">{{ valor.texto }}</a>
                      } @else {
                        {{ valor.texto }}
                      }
                    </span>
                  }
                </dd>
              </div>
            }
          </dl>

          <section class="ouvidoria-prazos" aria-labelledby="ouvidoria-prazos-titulo">
            <h3 class="ouvidoria-prazos-titulo" id="ouvidoria-prazos-titulo">Prazos de atendimento</h3>

            <dl class="ouvidoria-prazos-grade">
              @for (prazo of prazos(); track prazo.id) {
                <div class="ouvidoria-prazo">
                  <dt class="ouvidoria-prazo-rotulo">
                    <i-lucide [name]="prazo.icone" size="14" aria-hidden="true"></i-lucide>
                    <span>{{ prazo.rotulo }}</span>
                  </dt>

                  <dd class="ouvidoria-prazo-valor">{{ prazo.valor }}</dd>
                </div>
              }
            </dl>
          </section>

          <p class="ouvidoria-info-nota">
            <i-lucide name="info" size="16" aria-hidden="true"></i-lucide>
            Atendimento sujeito a alteração em feriados municipais.
          </p>
        </div>
      </section>
    } @else if (!carregando()) {
      <p class="ouvidoria-vazio" role="status">
        <i-lucide name="info" size="18" aria-hidden="true"></i-lucide>
        {{ naoPublicada }}
      </p>
    }
  </section>
</div>
